import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import { t, toLocaleCurrency } from 'helpers/i18n'
import { allowPricing } from 'helpers/auth'
import Filter from 'containers/Reports/InventoryReturnedItemsReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryReturnedItemsReport,
  filterTemplateType: 'InventoryReturnedItemsReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
  tableSummary: (self) =>
    allowPricing() ? `${t('totalValue:')} ${toLocaleCurrency(self.props.list?.totalValue ?? 0)}` : '',
})(Filter)
